import React from 'react'
import { useTbViewStore } from '@vt/hooks'
import { WebBasicFields } from '@ow/ditto'
import { pick } from 'lodash-es'

const Media = function ({ data }) {
  const { fields } = useTbViewStore((state) => pick(state, ['tbId', 'fields']))

  return (
    <div className="w-full flex flex-col">
      <WebBasicFields
        data={data}
        layout={{
          cols: 1,
          rows: 1,
          children: fields.filter((v) => v.type === 'media'),
        }}
        fields={fields}
        editableFields={[]}
        // widgets={widgets}
      />
    </div>
  )
}

export default Media
